import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfUnorderedList = ({ data }: Props) => {
  const { label } = data;
  const { item } = data;

  return (
    <>
      <h3 className="scroll-mt-16 px-2">{label}</h3>
      <ul className="list-disc pl-4 ml-4">
        {item.map((item, index) => (
          <li key={index} className="mb-3">
            {item}
          </li>
        ))}
      </ul>
    </>
  );
};
